import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { Draggable } from "gsap/Draggable";

gsap.registerPlugin(ScrollTrigger, Draggable);

export function marqueeAlianzas() {
  const marquee = document.querySelector('.marquee.alianzas');
  const track = marquee?.querySelector('.m-track');
  if (!marquee || !track) return;
  if (marquee.dataset.gsapInit === 'true') return;
  marquee.dataset.gsapInit = 'true';

  const trackWidth = track.scrollWidth / 2;
  const speed = trackWidth / 50; // pixels per second (consistent speed)
  const html = document.documentElement;
  
  // Disable CSS animation
  track.style.animation = 'none';
  
  let animation = null;
  let isPaused = false;
  
  // Function to start/restart animation from current position
  const startAnimation = () => {
    // Always kill existing animation first
    if (animation) {
      animation.kill();
      animation = null;
    }
    
    let currentX = gsap.getProperty(track, "x") || 0;
    
    // Normalize position to valid range
    currentX = currentX % trackWidth;
    if (currentX > 0) currentX -= trackWidth;
    
    // Calculate distance to travel and duration at constant speed
    const distanceToTravel = trackWidth - Math.abs(currentX);
    const remainingDuration = distanceToTravel / speed;
    
    // Create new animation from current position
    animation = gsap.to(track, {
      x: currentX - trackWidth,
      duration: remainingDuration,
      ease: "none",
      onComplete: () => {
        gsap.set(track, { x: 0 });
        if (!isPaused) startAnimation();
      }
    });
    
    isPaused = false;
  };
  
  // Pause animation
  const pauseAnimation = () => {
    isPaused = true;
    if (animation) animation.pause();
  };
  
  // Resume animation (continue from paused state or restart if needed)
  const resumeAnimation = () => {
    if (!isPaused) return;
    
    isPaused = false;
    
    // If animation exists and is paused, resume it
    if (animation && animation.paused()) {
      animation.resume();
    } else {
      // Otherwise restart from current position
      startAnimation();
    }
  };
  
  // Start initial animation
  startAnimation();

  // Reset marquee when modal closes
  if (html) {
    const modalObserver = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        if (mutation.attributeName === 'data-modal') {
          const isModalOpen = html.dataset.modal === 'on';
          
          if (!isModalOpen) {
            if (animation) animation.kill();
            gsap.set(track, { x: 0 });
            startAnimation();
          }
        }
      }
    });

    modalObserver.observe(html, {
      attributes: true,
      attributeFilter: ['data-modal']
    });
  }

  // Create Draggable
  Draggable.create(track, {
    type: "x",
    cursor: "grab",
    activeCursor: "grabbing",
    onDragStart: () => {
      pauseAnimation();
    },
    onDragEnd: () => {
      startAnimation();
    }
  });
}

// Default export - initialize all GSAP animations
export default function initGsap() {
  marqueeAlianzas();
}
